import {
  OrganizationModel,
  OrganizationAggregateModel,
  OrganizationProjectModel,
  ProjectModel,
} from '@/models/organizations/internal-models';
import { Organization, OrganizationAggregate, OrganizationProject } from '@/api/generated/model';

function mapFromAPIToProjectModel(data: OrganizationProject): ProjectModel {
  return {
    id: data.id,
    name: data.name,
    mappedProjectId: data.mapped_project_id || null,
    failureCategories: data.failure_categories || undefined,
    product: data.product ?? 'external',
    nReports: data.n_reports ?? 0,
    nReportsBySubproduct: data.n_reports_by_subproduct ?? {},
    enabledSubproducts: data.enabled_subproducts ?? ['experience'],
  };
}

export function mapFromApiToOrganizationModel(data: Organization): OrganizationModel {
  return {
    id: data.id,
    name: data.name,
    projects: data.projects?.map(mapFromAPIToProjectModel) ?? [],
    defaultAggregateBy: data.default_aggregate_by,
  };
}

export function mapFromApiToOrganizationAggregateModel(data: OrganizationAggregate): OrganizationAggregateModel {
  return {
    id: data.id,
    name: data.group_name,
    createdAt: data.created_at,
    nInteractions: data.n_interactions,
    nUsers: data.n_users,
    defaultAggregateBy: data.default_aggregate_by,
  };
}

export function mapFromAPIToOrganizationProjectModel(data: OrganizationAggregate): OrganizationProjectModel {
  return {
    id: data.id,
    name: data.group_name,
    createdAt: data.created_at,
    nInteractions: data.n_interactions,
    nUsers: data.n_users,
    isCustomProject: !!data.is_custom,
  };
}
